import { useCallback, useState } from "react";
import Slider from "react-slick";

const useCarousel = () => {
  const [nav1, setNav1] = useState<Slider | undefined>(undefined);
  const [nav2, setNav2] = useState<Slider | undefined>(undefined);
  const [slider1, setSlider1] = useState<Slider | null>(null);
  const [slider2, setSlider2] = useState<Slider | null>(null);

  const setNav1Callback = useCallback((slider: Slider) => setNav1(slider), []);
  const setNav2Callback = useCallback((slider: Slider) => setNav2(slider), []);
  const setSlider1Callback = useCallback(
    (slider: Slider | null) => setSlider1(slider),
    []
  );
  const setSlider2Callback = useCallback(
    (slider: Slider | null) => setSlider2(slider),
    []
  );

  return {
    nav1,
    nav2,
    slider1,
    slider2,
    setNav1: setNav1Callback,
    setNav2: setNav2Callback,
    setSlider1: setSlider1Callback,
    setSlider2: setSlider2Callback,
  };
};

export default useCarousel;
